const REPORTING_PREFIX = 'Web_Report_';
const SIDE_MENU_PREFIX = 'Web_SideMenu_';
const EDITOR_PREFIX = 'Web_Editor_';
const FOCUS_PREFIX = 'Web_FocusImport_';
const SETTINGS_PREFIX = 'Web_Settings_';
const PROCESSING_STATUS_PREFIX = 'Web_ProcessingStatus_';
const DATA_SHARING_PREFIX = 'Web_DataSharing_';
const PLANNING_PREFIX = 'Web_Planning_';

export const ACTIONS = {
    loaded: 'Page Loaded',
    unloaded: 'Page Unloaded',
    iconClicked: 'Icon Clicked',
    buttonClicked: 'Button Clicked',
    selected: 'Selected',
    deselected: 'Deselected',
    expanded: 'Expanded',
    opened: 'Opened',
    closed: 'Closed',
};

export const EVENTS = {
    sideMenu: {
        activitySearch: SIDE_MENU_PREFIX + 'ActivitySearch',
        activitySelection: SIDE_MENU_PREFIX + 'ActivitySelection',
    },
    reporting: {
        reportOpened: REPORTING_PREFIX + 'ReportOpened',
        reportClosed: REPORTING_PREFIX + 'ReportClosed',
        tabChanged: REPORTING_PREFIX + 'TabChanged',
        activityNameEditStarted: REPORTING_PREFIX + 'ActivityNameEditStarted',
        activityNameEditSubmitted: REPORTING_PREFIX + 'ActivityNameEditSubmitted',
        activityNameEditSuccess: REPORTING_PREFIX + 'ActivityNameEditSuccess',
        activityNameEditFailure: REPORTING_PREFIX + 'ActivityNameEditFailure',
        athleteParticipationGroupViewed: REPORTING_PREFIX + 'AthleteParticipationGroupViewed',
        reportExport: REPORTING_PREFIX + 'ReportExport',
        reportToEditActivity: REPORTING_PREFIX + 'ReportToEditActivity',
        periodInsights: REPORTING_PREFIX + 'PeriodInsights',
        athleteInsights: REPORTING_PREFIX + 'AthleteInsights',
        compareToFilter: REPORTING_PREFIX + 'CompareToFilter',
        filter: REPORTING_PREFIX + 'Filter',
        periodSortView: REPORTING_PREFIX + 'PeriodSortView',
        periodSort: REPORTING_PREFIX + 'PeriodSort',
        athleteChartSortView: REPORTING_PREFIX + 'AthleteChartSortView',
        athleteChartSort: REPORTING_PREFIX + 'AthleteChartSort',
        athleteChartFilterView: REPORTING_PREFIX + 'AthleteChartFilterView',
        athleteChartFilter: REPORTING_PREFIX + 'AthleteChartFilter',
        parameterUpdate: REPORTING_PREFIX + 'ParameterUpdate',
        reportTypeSelection: REPORTING_PREFIX + 'ReportTypeSelection',
        athletePeriodChartSortView: REPORTING_PREFIX + 'AthletePeriodChartSortView',
        athletePeriodChartSort: REPORTING_PREFIX + 'AthletePeriodChartSort',
        athletePeriodChartFilterView: REPORTING_PREFIX + 'AthletePeriodChartFilterView',
        athletePeriodChartFilter: REPORTING_PREFIX + 'AthletePeriodChartFilter',
        dailyBreakdownChartSort: REPORTING_PREFIX + 'DailyBreakdownChartSort',
        dailyBreakdownChartSortView: REPORTING_PREFIX + 'DailBreakdownChartSortView',
        dailyBreakdownChartFilterView: REPORTING_PREFIX + 'DailyBreakdownChartFilterView',
        tagFilter: REPORTING_PREFIX + 'TagFilter',
        heatMapSelected: REPORTING_PREFIX + 'HeatMapSelected',
        traceMapSelected: REPORTING_PREFIX + 'TraceMapSelected',
        venueCreated: REPORTING_PREFIX + 'VenueCreated',
        dateSelected: REPORTING_PREFIX + 'DateSelected',
        performanceFlagSidePanel: REPORTING_PREFIX + 'PerformanceFlagSidePanel',
        performanceFlag: REPORTING_PREFIX + 'PerformanceFlag',
        performanceFlagNameChanged: REPORTING_PREFIX + 'PerformanceFlagNameChanged',
        performanceFlagCreated: REPORTING_PREFIX + 'PerformanceFlagCreated',
        performanceFlagDeleted: REPORTING_PREFIX + 'PerformanceFlagDeleted',
        performanceFlags: REPORTING_PREFIX + 'PerformanceFlags',
        performanceFlagReordered: REPORTING_PREFIX + 'PerformanceFlagReordered',
        performanceFlagTypeChanged: REPORTING_PREFIX + 'PerformanceFlagTypeChanged',
        performanceFlagAttributeChanged: REPORTING_PREFIX + 'PerformanceFlagAttributeChanged',
        intervalChanged: REPORTING_PREFIX + 'AnnotationChartIntervalChanged',
        matchdayAthleteChartSortView: REPORTING_PREFIX + 'MatchdayAthleteChartSortView',
        matchdayAthleteChartSort: REPORTING_PREFIX + 'MatchdayAthleteChartSort',
        matchdayAthleteChartFilterView: REPORTING_PREFIX + 'MatchdayAthleteChartFilterView',
        matchdayAthleteChartFilter: REPORTING_PREFIX + 'MatchdayAthleteChartFilter',
        matchdayActivityChanged: REPORTING_PREFIX + 'MatchdayActivityChange',
        sharedLinkLogin: REPORTING_PREFIX + 'SharedLinkLogin',
        scorelineEdited: REPORTING_PREFIX + 'ScorelineEdited',
        weeklyReportWeekFiltered: REPORTING_PREFIX + 'WeeklyReportWeekFiltered',
        effortTypeSelection: REPORTING_PREFIX + 'EffortTypeSelection',
        effortInteraction: REPORTING_PREFIX + 'EffortInteraction',
        customColorPicked: REPORTING_PREFIX + 'CustomColorPicked',
        barChartZoomToggled: REPORTING_PREFIX + 'BarchartZoomToggled',
        editModeChartAdded: REPORTING_PREFIX + 'ChartAdded',
        editModeChartDeleted: REPORTING_PREFIX + 'ChartDeleted',
        editModeChartRecolor: REPORTING_PREFIX + 'ChartColorChange',
        editModeChartRename: REPORTING_PREFIX + 'ChartNameChange',
        tableExport: REPORTING_PREFIX + 'TableExport',
    },
    editing: {
        periodCreated: EDITOR_PREFIX + 'PeriodCreated',
        periodEdit: EDITOR_PREFIX + 'PeriodEdited',
        periodRenamed: EDITOR_PREFIX + 'PeriodRenamed',
        periodTemplateSelected: EDITOR_PREFIX + 'PeriodTemplateSelected',
        editPeriodTagsModalOpened: EDITOR_PREFIX + 'EditPeriodTagsModalOpened',
        periodDelete: EDITOR_PREFIX + 'PeriodDeleted',
        deviceUnmapped: EDITOR_PREFIX + 'DeviceUnmapped',
        deviceMapped: EDITOR_PREFIX + 'DeviceMapped',
        dayCodeTagChanged: EDITOR_PREFIX + 'DayCodeTagChanged',
        participationTagChanged: EDITOR_PREFIX + 'ParticipationTagChanged',
        graphToolSelectionChanged: EDITOR_PREFIX + 'GraphToolSelectionChanged',
        graphRendered: EDITOR_PREFIX + 'GraphRendered',
        zoomToPeriod: EDITOR_PREFIX + 'ZoomToPeriod',
        zoomReset: EDITOR_PREFIX + 'ZoomReset',
        zoomOnSelection: EDITOR_PREFIX + 'ZoomOnSelection',
        zoomOnClick: EDITOR_PREFIX + 'ZoomOnClick',
        zoomOnPinch: EDITOR_PREFIX + 'ZoomOnPinch',
        zoomOnDrag: EDITOR_PREFIX + 'ZoomOnDrag',
        zoomOnKeypress: EDITOR_PREFIX + 'ZoomOnKeypress',
        webEditorViewSelected: EDITOR_PREFIX + 'WebEditorViewSelected',
        athletesAdded: EDITOR_PREFIX + 'Athletes_Added',
        athletesRemoved: EDITOR_PREFIX + 'Athletes_Removed',
        selectAllPeriods: EDITOR_PREFIX + 'SelectAllPeriods',
        rotationCreated: EDITOR_PREFIX + 'RotationCreated',
        rotationAdjusted: EDITOR_PREFIX + 'RotationAdjusted',
        rotationMerged: EDITOR_PREFIX + 'RotationMerged',
        rotationMultiApplied: EDITOR_PREFIX + 'RotationMultiApplied',
        rotationApplyModeChanged: EDITOR_PREFIX + 'RotationApplyModeChanged',
        annotationDelete: EDITOR_PREFIX + 'AnnotationDeleted',
        sortAthletes: EDITOR_PREFIX + 'SortAthletes',
        searchAthletes: EDITOR_PREFIX + 'SearchAthletes',
        annotationRenamed: EDITOR_PREFIX + 'AnnotationRenamed',
        annotationCategoryRenamed: EDITOR_PREFIX + 'AnnotationCategoryRenamed',
        annotationEdited: EDITOR_PREFIX + 'AnnotationEdited',
        annotationCategoryCreated: EDITOR_PREFIX + 'CategoryCreated',
        annotationCreated: EDITOR_PREFIX + 'AnnotationCreated',
        createAnnotationCategorySource: EDITOR_PREFIX + 'CreateAnnotationCategorySource',
        moveAthletes: EDITOR_PREFIX + 'MoveAthletes',
        iceHockeyShiftsButtonPress: EDITOR_PREFIX + 'IceHockeyShiftsButtonPress',
        intervalBatchCreated: EDITOR_PREFIX + 'IntervalBatchCreated',
        graphedEvents: EDITOR_PREFIX + 'GraphedEvents',
        activityTagAdded: EDITOR_PREFIX + 'ActivityTagAdded',
        activityTagCreated: EDITOR_PREFIX + 'ActivityTagCreated',
        activityTagDeleted: EDITOR_PREFIX + 'ActivityTagDeleted',
        webGpuUnavailable: EDITOR_PREFIX + 'WebGpuUnavailable',
        webGpuBufferLimit: EDITOR_PREFIX + 'WebGpuBufferLimit',
        athletesGraphed: EDITOR_PREFIX + 'AthletesGraphed',
        athletePanelTabSelected: EDITOR_PREFIX + 'AthletePanelTabSelected',
        groupToggled: EDITOR_PREFIX + 'AthleteGroupToggled',
        groupAthletesSelected: EDITOR_PREFIX + 'GroupAthletesSelected',
    },
    focus: {
        startUpPageModal: FOCUS_PREFIX + 'StartUpPageModal',
        startUpPageModalImportOptionChanged: FOCUS_PREFIX + 'startUpPageModalImportOptionChanged',
        startUpPageModalStarted: FOCUS_PREFIX + 'StartUpPageModalStarted',
        startUpPageModalEnded: FOCUS_PREFIX + 'StartUpPageModalEnded',
        alignPeriod: FOCUS_PREFIX + 'AlignPeriod',
        alignPeriodOptionChanged: FOCUS_PREFIX + 'AlignPeriodOptionChanged',
        alignPeriodStarted: FOCUS_PREFIX + 'AlignPeriodStarted',
        alignPeriodEnded: FOCUS_PREFIX + 'AlignPeriodEnded',
        tagImport: FOCUS_PREFIX + 'TagImport',
        tagImportAliasUpdated: FOCUS_PREFIX + 'TagImportAliasUpdated',
        tagImportAliasSelectionMade: FOCUS_PREFIX + 'TagImportAliasSelectionMade',
        tagImportStarted: FOCUS_PREFIX + 'TagImportStarted',
        tagImportEnded: FOCUS_PREFIX + 'TagImportEnded',
        athleteParticipation: FOCUS_PREFIX + 'AthleteParticipation',
        athleteParticipationStarted: FOCUS_PREFIX + 'AthleteParticipationStarted',
        athleteParticipationEnded: FOCUS_PREFIX + 'AthleteParticipationEnded',
        athleteParticipationAssignOption: FOCUS_PREFIX + 'AthleteParticipationAssignOption',
        athleteParticipationTypeSelected: FOCUS_PREFIX + 'AthleteParticipationTypeSelected',
        athleteParticipationByTagTypeSelection: FOCUS_PREFIX + 'athleteParticipationByTagTypeSelection',
        athleteParticipationByLabelSelection: FOCUS_PREFIX + 'athleteParticipationByLabelSelection',
        mapAthletes: FOCUS_PREFIX + 'MapAthletes',
        mapAthletesEnded: FOCUS_PREFIX + 'MapAthletesEnded',
        importSubmitted: FOCUS_PREFIX + 'ImportSubmitted',
    },
    settings: {
        pageOpened: SETTINGS_PREFIX + 'Opened',
        pageClosed: SETTINGS_PREFIX + 'Closed',
        athletes: {
            globallyFiltered: SETTINGS_PREFIX + 'AthletesGloballyFiltered',
            athleteImportClicked: SETTINGS_PREFIX + 'AthleteImportClicked',
            addAthleteClicked: SETTINGS_PREFIX + 'AddAthleteClicked',
            singleSelect: SETTINGS_PREFIX + 'AthleteSelected',
            selectAll: SETTINGS_PREFIX + 'AllAthletesSelected',
            filterColumn: SETTINGS_PREFIX + 'AthleteColumnFiltered',
            sortColumn: SETTINGS_PREFIX + 'AthleteColumnSorted',
            archive: SETTINGS_PREFIX + 'ArchiveAthletesTriggered',
            unarchive: SETTINGS_PREFIX + 'UnarchiveAthletesTriggered',
            updated: SETTINGS_PREFIX + 'AthleteUpdated',
            edit: SETTINGS_PREFIX + 'AthleteEditSelected',
            jerseyMaxHit: SETTINGS_PREFIX + 'JerseyMaxCombinationsHit',
        },
        groups: {
            created: SETTINGS_PREFIX + 'AthleteGroupCreated',
            createFailed: SETTINGS_PREFIX + 'AthleteGroupCreateFailed',
            renamed: SETTINGS_PREFIX + 'AthleteGroupRenamed',
            duplicated: SETTINGS_PREFIX + 'AthleteGroupDuplicated',
            duplicateFailed: SETTINGS_PREFIX + 'AthleteGroupDuplicateFailed',
            deleted: SETTINGS_PREFIX + 'AthleteGroupDeleted',
            deleteFailed: SETTINGS_PREFIX + 'AthleteGroupDeleteFailed',
            deleteModalOpened: SETTINGS_PREFIX + 'AthleteGroupDeleteModalOpened',
            athletesUpdated: SETTINGS_PREFIX + 'AthleteGroupAthletesUpdated',
            selectAll: SETTINGS_PREFIX + 'AthleteGroupSelectAll',
            filtersToggled: SETTINGS_PREFIX + 'AthleteGroupFiltersToggled',
            filterChanged: SETTINGS_PREFIX + 'AthleteGroupFilterChanged',
            searched: SETTINGS_PREFIX + 'AthleteGroupSearched',
            sidebarToggled: SETTINGS_PREFIX + 'AthleteGroupsSidebarToggled',
        },
        periodTemplates: {
            created: SETTINGS_PREFIX + 'PeriodTemplateCreated',
            createFailed: SETTINGS_PREFIX + 'PeriodTemplateCreateFailed',
            updated: SETTINGS_PREFIX + 'PeriodTemplateUpdated',
            updateFailed: SETTINGS_PREFIX + 'PeriodTemplateUpdateFailed',
            deleted: SETTINGS_PREFIX + 'PeriodTemplateDeleted',
            deleteFailed: SETTINGS_PREFIX + 'PeriodTemplateDeleteFailed',
            createModalOpened: SETTINGS_PREFIX + 'PeriodTemplateCreateModalOpened',
            editModalOpened: SETTINGS_PREFIX + 'PeriodTemplateEditModalOpened',
            deleteModalOpened: SETTINGS_PREFIX + 'PeriodTemplateDeleteModalOpened',
            moreOptionsItemSelected: SETTINGS_PREFIX + 'PeriodTemplateMoreOptionsItemSelected',
            manageTagsModalOpened: SETTINGS_PREFIX + 'PeriodTemplateManageTagsModalOpened',
            tagCategoryAdded: SETTINGS_PREFIX + 'PeriodTemplateTagCategoryAdded',
            tagCategoryRemoved: SETTINGS_PREFIX + 'PeriodTemplateTagCategoryRemoved',
            tagCreated: SETTINGS_PREFIX + 'PeriodTemplateTagCreated',
            importPageOpened: SETTINGS_PREFIX + 'PeriodTemplateImportPageOpened',
            templatesExported: SETTINGS_PREFIX + 'PeriodTemplatesExported',
            importApplied: SETTINGS_PREFIX + 'PeriodTemplateImportApplied',
        },
        positions: {
            addModalOpened: SETTINGS_PREFIX + 'PositionAddModalOpened',
            editModalOpened: SETTINGS_PREFIX + 'PositionEditModalOpened',
            deleteModalOpened: SETTINGS_PREFIX + 'PositionDeleteModalOpened',
            created: SETTINGS_PREFIX + 'PositionCreated',
            createFailed: SETTINGS_PREFIX + 'PositionCreateFailed',
            updated: SETTINGS_PREFIX + 'PositionUpdated',
            updateFailed: SETTINGS_PREFIX + 'PositionUpdateFailed',
            deleted: SETTINGS_PREFIX + 'PositionDeleted',
            deleteFailed: SETTINGS_PREFIX + 'PositionDeleteFailed',
            searched: SETTINGS_PREFIX + 'PositionsSearched',
            sportFiltered: SETTINGS_PREFIX + 'PositionsSportFiltered',
        },
    },
    processingStatus: {
        modalOpened: PROCESSING_STATUS_PREFIX + 'ModalOpened',
    },
    planning: {
        plannerOpened: PLANNING_PREFIX + 'PlannerOpened',
        plannerClosed: PLANNING_PREFIX + 'PlannerClosed',
        tabSelected: PLANNING_PREFIX + 'PlannerTabSelected',
        rowSelectionChanged: PLANNING_PREFIX + 'PlannerRowSelectionChanged',
        editorOpened: PLANNING_PREFIX + 'EditorOpened',
        planSaved: PLANNING_PREFIX + 'PlanSaved',
        planSaveFailed: PLANNING_PREFIX + 'PlanSaveFailed',
        planDuplicated: PLANNING_PREFIX + 'PlanDuplicated',
        planDeleted: PLANNING_PREFIX + 'PlanDeleted',
        templateApplied: PLANNING_PREFIX + 'TemplateApplied',
        athletesAssigned: PLANNING_PREFIX + 'AthletesAssigned',
        discardConfirmed: PLANNING_PREFIX + 'DiscardConfirmed',
        periodAdded: PLANNING_PREFIX + 'PeriodAdded',
        periodDuplicated: PLANNING_PREFIX + 'PeriodDuplicated',
        periodRemoved: PLANNING_PREFIX + 'PeriodRemoved',
        periodsReordered: PLANNING_PREFIX + 'PeriodsReordered',
        athletePickerTabSelected: PLANNING_PREFIX + 'AthletePickerTabSelected',
        groupToggled: PLANNING_PREFIX + 'AthleteGroupToggled',
        groupAthletesAdded: PLANNING_PREFIX + 'GroupAthletesAdded',
    },
    dataSharing: {
        // Account Connections
        connectionsPageOpened: DATA_SHARING_PREFIX + 'ConnectionsPageOpened',
        generateCodeModalOpened: DATA_SHARING_PREFIX + 'GenerateCodeModalOpened',
        codeGenerated: DATA_SHARING_PREFIX + 'CodeGenerated',
        codeCopied: DATA_SHARING_PREFIX + 'CodeCopied',
        inputCodeModalOpened: DATA_SHARING_PREFIX + 'InputCodeModalOpened',
        codeValidated: DATA_SHARING_PREFIX + 'CodeValidated',
        codeValidationFailed: DATA_SHARING_PREFIX + 'CodeValidationFailed',
        connectionApproved: DATA_SHARING_PREFIX + 'ConnectionApproved',
        approvalFailed: DATA_SHARING_PREFIX + 'ApprovalFailed',
        connectionUpdated: DATA_SHARING_PREFIX + 'ConnectionUpdated',
        connectionConfigured: DATA_SHARING_PREFIX + 'ConnectionConfigured',
        connectionDetailsOpened: DATA_SHARING_PREFIX + 'ConnectionDetailsOpened',
        connectionMetadataUpdated: DATA_SHARING_PREFIX + 'ConnectionMetadataUpdated',
        connectionDisconnected: DATA_SHARING_PREFIX + 'ConnectionDisconnected',

        // Share Creation
        createShareStarted: DATA_SHARING_PREFIX + 'CreateShareStarted',
        createShareAccountSelected: DATA_SHARING_PREFIX + 'AccountSelected',
        createShareAthletesSelected: DATA_SHARING_PREFIX + 'AthletesSelected',
        createShareDateRangeSelected: DATA_SHARING_PREFIX + 'DateRangeSelected',
        createShareMetadataEdited: DATA_SHARING_PREFIX + 'MetadataEdited',
        createShareRefreshTriggered: DATA_SHARING_PREFIX + 'ShareRefreshButtonTriggered',
        createShareMissingWarningShown: DATA_SHARING_PREFIX + 'MissingFilesWarningShown',
        createShareMissingRemoved: DATA_SHARING_PREFIX + 'ShareAthletesWithMissingRemoved',
        createShareFilesReviewed: DATA_SHARING_PREFIX + 'ShareFilesReviewed',
        createShareReviewed: DATA_SHARING_PREFIX + 'ShareReviewed',
        shareSent: DATA_SHARING_PREFIX + 'ShareSent',
        shareSendFailed: DATA_SHARING_PREFIX + 'ShareSendFailed',
        shareDiscarded: DATA_SHARING_PREFIX + 'ShareDiscarded',

        // Receive Flow
        receiveFlowStarted: DATA_SHARING_PREFIX + 'ReceiveFlowStarted',
        receiveAthletesMapped: DATA_SHARING_PREFIX + 'AthletesMapped',
        receiveReviewMaxesSkipped: DATA_SHARING_PREFIX + 'ReviewMaxesSkipped',
        receiveReviewMaxesCompleted: DATA_SHARING_PREFIX + 'ReviewMaxesCompleted',
        shareAccepted: DATA_SHARING_PREFIX + 'ShareAccepted',
        shareAcceptFailed: DATA_SHARING_PREFIX + 'ShareAcceptFailed',
        shareDeclined: DATA_SHARING_PREFIX + 'ShareDeclined',
        receiveAthleteCreated: DATA_SHARING_PREFIX + 'AthleteCreated',
        shareJobFinished: DATA_SHARING_PREFIX + 'ShareJobFinished',

        // General / Drop-off
        tabChanged: DATA_SHARING_PREFIX + 'TabChanged',
        shareCancelled: DATA_SHARING_PREFIX + 'ShareCancelled',
        flowAbandoned: DATA_SHARING_PREFIX + 'FlowAbandoned',
    },
};
